// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__3Cvfx","googleplay":"Footer_googleplay__3SsEA"};